<p-dropdown
  [options]="institutions"
  optionLabel="name"
  [filter]="true"
  filterBy="name"
  [showClear]="true"
  placeholder="Choose the institution"
  optionValue="id"
  [ngClass]="errorClass"
  (onChange)="onDropdownChange($event)"
  [appendTo]="'body'"
  [(ngModel)]="selectedValue"
>
</p-dropdown>
